import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import React from "react"
import HyperDiv from "../../../../ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import IconButton from "../atoms/Buttons/IconButton"
import { saveAs } from "file-saver"

interface Props {
	data: File[]
	onRemove?: TOnRemove
}

const FilesRepr = ({ data, onRemove = () => {} }: Props) => {
	return (
		<>
			<HyperDiv direction="column" spaceBetweenElems="0.5rem" wraps>
				{data.map((file, i) => {
					let { name } = file

					return (
						<HyperDiv key={i} direction="row" style={{ overflow: "hidden" }}>
							<HyperDiv
								className="pointer"
								hidesOverflownText
								onClick={() => {
									file.arrayBuffer().then((arrayBuffer) => {
										saveAs(new Blob([new Uint8Array(arrayBuffer)], { type: file.type }), file.name)
									})
								}}
							>
								{name}
							</HyperDiv>
							<Whitespace h x="1" />
							<IconButton iconKey="cross" iconHeight="20px" onClick={() => onRemove(i)} />
						</HyperDiv>
					)
				})}
			</HyperDiv>
		</>
	)
}

export default FilesRepr

export type TOnRemove = (index: number) => void
